export enum ADDRESS_STATUS {
  UNDEFINED,
  NOT_VALIDATED,
  VALIDATED_WITH_WARNINGS,
  VALIDATED,
  SUPERADMIN_VALIDATED,
}
